const colors = {
  light: "#f5fafb",
  primary: "#0066fe",
  secondary: "#f36d66",
};

export default colors;
